function toggleNavMobile() {
    const navId = document.getElementById('top-nav');
    if (navId) {
        navId.classList.toggle('responsive');
    }
} 

export default toggleNavMobile;